import { TypedUseSelectorHook, useSelector as reduxSelector, useStore as useReduxStore } from 'react-redux';
import { Store } from 'redux';

import type { SpeedyFlowState } from '@/components/SpeedyFlow/types';
import { TermsState } from '@/components/TermsAndConditions/redux/types';
import { Habitat, HabitatListItem } from '@/queries/habitats/types';
import type { HabitatCardsMobileStates } from '@/routes/habitat/components/CardTabs/Mobile/slice';

import { DeviceSettingsState } from './slices/deviceSettings/types';
/** @deprecated Migration-only; runtime progress is `tours`. */
import type { GuidedTourState } from './slices/guidedTour';
import MyAlbumState from './slices/myAlbum/types';
import { RemoteConfigState } from './slices/remoteConfig/types';
import type { SettingsState } from './slices/settings';
import type { ToursState } from './slices/tours';
import { UserState } from './slices/user/types';

export type AppState = {
  user: UserState;
  /** @deprecated Migration-only persisted slice. */
  guidedTour: GuidedTourState;
  tours: ToursState;
  settings: SettingsState;
  deviceSettings: DeviceSettingsState;
  myAlbum: MyAlbumState;
  remoteConfig: RemoteConfigState;
  habitat: {
    mobileCards: HabitatCardsMobileStates;
    habitatInfo: Habitat & { [key: string]: any };
    [key: string]: any;
  };
  modals: {
    speedyFlow: SpeedyFlowState;
    terms: TermsState;
    [key: string]: any;
  };

  // type only slice, not yet migrated
  allHabitats: HabitatListItem[];

  // others non migrated slices
  [slice: string]: any;
};

export const useSelector: TypedUseSelectorHook<AppState> = reduxSelector;
export const useStore: () => Store<AppState> = useReduxStore;
